import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mx-auto" }, "Fetching secure payment form ...", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  role: "status",
  class: "w-20 h-20 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600 mx-auto mt-20",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  ref: "card",
  id: "cardHome"
}
const _hoisted_6 = { class: "text-red-500" }

import { HoodApi } from "@/services/HoodApi";
import { StripeElements } from "@stripe/stripe-js";
import { StripeService } from "@/services/StripeService";
import { reactive, ref } from "vue";
interface StripeError {
  code: string;
  message: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(true);
const pk = process.env?.VUE_APP_STRIPE_API_KEY;
// const pk =
//   "pk_test_51KzlHSEBxohKpgZBXc3QKnBHL8h4YlGtI1CDQFEqo2Y43mOlyLffpmg5Z74RhrMzkxu23qXhxkWZ9CJIUpBf9twZ00nxS9JOoZ";
let elements: StripeElements | null = null;
const error = ref("");
const payment = ref({});

const pay = () => {
  console.log("paying");
};

const create_intent = async () => {
  console.log("Stripe key");
  console.log(process.env?.VUE_APP_STRIPE_API_KEY);
  const elementsResposne = await StripeService.create_elements("na");

  //   payment.value = elementsResposne.payment;
  elements = elementsResposne.elements;
  if (elements) {
    elements.create("payment").mount("#cardHome");
  }
  loading.value = false;
};

const handleSubmit = async (e: any) => {
  try {
    await StripeService.submit_payment(elements as StripeElements);
  } catch (e: unknown) {
    console.log(e);
    const currentError = e as StripeError;
    error.value = currentError.message;
    // attach the error to the payment
  }
};

create_intent();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("form", {
      id: "payment-form",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleSubmit($event)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, null, 512),
      _createElementVNode("p", _hoisted_6, _toDisplayString(error.value), 1),
      _createElementVNode("button", {
        class: "bg-blue-500 text-white px-8 py-4 rounded-md mt-4",
        onClick: pay
      }, " Pay ")
    ], 544), [
      [_vShow, !loading.value]
    ])
  ], 64))
}
}

})